export const EKeyStateModalAuth =  {
    SIGN_IN : 1,
    SIGN_UP : 2,
    FORGOT_PASSWORD : 3,
    VERIFY_OTP_FORGOT : 4,
    CHANGE_PASSWORD : 5,
    VERIFY_OTP_REGISTER : 'VERIFY_OTP_REGISTER',
};
  